import React from 'react';
import { ContractTabProps } from 'routes/Contracts/ContractDetail/navigation-tab/contract-config-tabs';

const Documents: React.FC<ContractTabProps> = () => (
  <div className="p-4 bg-white rounded-lg">
    <h3 className="text-lg font-semibold mb-4">Documents</h3>
    <p>Documents content goes here...</p>
  </div>
);

export default Documents;
